import type { Read } from "@/components/ui/box.schema";
import type { SessionWorkspace } from "@/lib/api/sessionPortal";

export type SessionBoxId = "follow-up" | "prepare" | "teach" | "close" | "get-ready" | "hand-in";

/**
 * A box's rank from the page's one ranking read (P2). A stale page, a ranking
 * that isn't ready, or a box the server didn't rank has no rank: the client
 * invents no order.
 */
export function rankOf(read: Read<SessionWorkspace>, box: SessionBoxId): number | null {
  if (read.status !== "ready") return null;
  const { ranking } = read.value;
  if (ranking?.state !== "ready") return null;
  return ranking.value.candidates.find((candidate) => candidate.id === box)?.rank ?? null;
}
